<template>
    <div class="message-list" v-bind:class="item.user === null ? 'admin' : ''">
        <div class="wrap-avatar">
            <img :src="item.user !== null ? item.user.avatar : item.admin.avatar" alt="">
        </div>
        <div class="wrap-body">
            <div class="wrap-user">
                <div class="name">{{item.user !== null ? item.user.firstname + ' ' + item.user.lastname : item.admin.name}}</div>
                <div class="date">{{moment(item.created_at)}}</div>
            </div>
            <div class="wrap-user" v-html="item.message"></div>
            <div class="wrap-attachment" v-if="item.attachments.length > 0">
                <div class="title">Attachments:</div>
                <div class="file" v-for="item in item.attachments">
                    <a :href="item.link" target="_blank">{{ item.filename }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "TicketMessage",
    props: ["item"],
    methods: {
        moment (date) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        },
    }
}
</script>

<style scoped>
.message-list {
    display: flex;
    background: rgb(249 249 249);
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}
.message-list.admin {
    border-top: 5px solid #ec550e;
    background: #fff;
}
.message-list .wrap-body {
    width: 100%;
}
.wrap-avatar {
    margin-right: 15px;
    width: 100px;
    height: 100px;
}
.wrap-avatar img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
}
.wrap-user {
    margin-bottom: 15px;
}
.wrap-user .name {
    font-weight: bold;
}
.wrap-user .date {
    font-style: italic;
    font-size: 12px;
}
.wrap-attachment {
    padding: 15px;
    border: 1px solid #eee;
}
.wrap-attachment .title {
    font-weight: bold;
}
.wrap-attachment .file {
    font-size: 13px;
    color: #EC550E;
}

@media only screen and (max-width: 600px) {
    .message-list {
        display: flex;
        flex-direction: column;
        margin: 0 7px 10px 7px;
    }
    .wrap-avatar {
        width: 55px;
        height: 55px;
    }
    .wrap-avatar img {
        width: 55px;
        height: 55px;
        border-radius: 50%;
    }
}
</style>
